import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function SystemintegrationPhilosophie() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="systemintegration-philosophie" className="dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-64 bg-primary/10 blur-[120px] rounded-full pointer-events-none" />
      <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-secondary/5 blur-[100px] rounded-full pointer-events-none" />

      <div ref={ref} className={cn("max-w-3xl mx-auto text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <h2 className="text-3xl md:text-4xl font-bold mb-12 tracking-tight text-foreground">
          Systemintegration & Philosophie
        </h2>

        <div className="space-y-8 text-lg md:text-xl text-muted-foreground leading-relaxed">
          <p>Wir kommen aus der Industrie – und das merkt man. Wo andere Einzellösungen aneinanderreihen, denken wir Gebäude als Gesamtsystem. Heizung, Beleuchtung, Beschattung, Energie – alles muss zusammenspielen, nicht nur einzeln funktionieren. Unsere drei Grundsätze dabei:<br /><div data-ast-id="f:/src/pages/AboutUs/sections/SystemintegrationPhilosophie.tsx|sig:5mi6sw" data-ast-start="1275" data-ast-end="1588"><div data-ast-id="f:/src/pages/AboutUs/sections/SystemintegrationPhilosophie.tsx|sig:5le0up" data-ast-start="1482" data-ast-end="1515">• Technische Präzision</div><div data-ast-id="f:/src/pages/AboutUs/sections/SystemintegrationPhilosophie.tsx|sig:5kymxx" data-ast-start="1515" data-ast-end="1548">• Zuverlässige Systeme</div><div data-ast-id="f:/src/pages/AboutUs/sections/SystemintegrationPhilosophie.tsx|sig:5kwnr8" data-ast-start="1548" data-ast-end="1582">• Langfristige Lösungen</div></div></p>

          <p>Wir setzen bewusst auf bewährte Technologien und offene Systeme – damit Ihre Anlage auch in zehn Jahren noch flexibel erweiterbar ist.</p>

          
        </div>
      </div>
    </section>;
}